import { render, staticRenderFns } from "./JobOfferDetails.vue?vue&type=template&id=5f1e645f&"
import script from "./jobOfferDetails.js?vue&type=script&lang=js&"
export * from "./jobOfferDetails.js?vue&type=script&lang=js&"
import style0 from "./JobOfferDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports